import { BUSINESS_TRAVELLER_ROOT_ROUTE } from 'businessTraveller/routes/businessTravellerRoutes'
import ContactOptionsBanner from 'components/App/Header/HeaderBanners/ContactOptionsBanner'
import LogoIcon from 'components/App/Header/Logo/LogoIcon'
import Clickable from 'components/Common/Clickable'
import ContactOptions from 'components/Common/ContactOptions'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const HeaderContainer = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  border-bottom: 1px solid ${props => props.theme.palette.neutral.default.five};
  height: ${rem(60)};

  ${mediaQueryUp.tablet} {
    border: none;
    height: ${rem(74)};
  }
`

const StyledLayoutContainer = styled(LayoutContainer)`
  height: 100%;
`

export default function BusinessTravellerSupportHeader() {
  return (
    <Group direction="vertical">
      <CSSBreakpoint max="mobile">
        <ContactOptionsBanner/>
      </CSSBreakpoint>
      <HeaderContainer>
        <StyledLayoutContainer>
          <Group direction="horizontal" horizontalAlign="space-between" gap={8} verticalAlign="center" fullHeight>
            <Clickable to={BUSINESS_TRAVELLER_ROOT_ROUTE}>
              <LogoIcon/>
            </Clickable>
            <CSSBreakpoint min="tablet">
              <ContactOptions/>
            </CSSBreakpoint>
          </Group>
        </StyledLayoutContainer>
      </HeaderContainer>
    </Group>
  )
}
